






























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';

@Component
export default class ListFiles extends Vue {
  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;
  @Prop({ default: '' }) public title: string;
  @Prop({ default: 200 }) public height: number;
  @Prop({ default: false }) public electronicBookMode: boolean;

  @Prop({ default: null }) public parentKey: string; //伝票区分
  @Prop({ default: null }) public parentId: string; //伝票キー
  @Prop({ default: false }) public isAdmin: boolean; //管理サイトの添付ファイル取得
  public items: any[] = new Array(0); //リスト
  public selectedItem: any = null; //リスト選択中の項目
  public showUpload: boolean = false;
  public showDescription: boolean = false;
  public description: string = '';
  public tag : string = null;

  //IControl～親Editorから呼び出される
  public isEdit: boolean = true;
  public validator: Components.ControlValidator = null;
  public isLoading :boolean = false;
  public created() {
    //親Editorに登録する=>編集可否判定を優先してeditorのバインドを無効化
    // if (this.editor != null) this.editor.addControl(this);

  }
  mounted(){
    this.onParentIdChanged();
  }

  @Watch('parentId') 
  @Watch('isAdmin')   
  public onParentIdChanged(){
    const query = new Common.UploadFileQuery();
    query.parentKey = this.parentKey;
    query.parentId = this.parentId;
    query.isAdmin = this.isAdmin;
    this.isLoading = true;
    this.$api.execute(query)
      .then((data: Common.UploadFile[]) => {
        this.isLoading = false;
        this.items = data;
      });
  }

  public get Grid(): Components.Grid {
    return this.$refs.listBox as Components.Grid;
  }

  public onSelected(index: number) {
    this.selectedItem = this.items[index];
  }

  //***********   要実装箇所 *************/

  public onUpload() {
    if(this.$refs.file != null) (this.$refs.file as any).value = '';
    this.description = '';
    this.showUpload = true;
  }

  public onDescription(index: number) {
    this.onSelected(index);
    const obj = this.selectedItem as Common.UploadFile;
    this.description = obj.description;
    this.tag = obj.tag;
    this.showDescription = true;
  }

  public onAdd() {
    const obj = (this.$refs.file as any).files as FileList;
    if (obj.length == 0) return;
    const query = new Common.UploadFileUploadQuery();
    query.parentKey = this.parentKey;
    query.parentId = this.parentId;
    query.description = this.description;
    query.tag = this.tag ? this.tag: null;
    query.uploadPIC =  this.$api.auth.userId;
    for (var i = 0; i < obj.length; i++) {
      let file = obj[i];
      query.timestamps += new Date(file.lastModified).toISOString() + ',';
    }

    this.$api.upload(query, obj)
    .then(response => {
        (response as any[]).forEach(obj=> this.$set(this.items, this.items.length,obj))
    }
    );

  }

  public onEdit() {
    const obj = this.selectedItem as Common.UploadFile;
    obj.description = this.description;
    obj.tag = this.tag ? this.tag: null;
    this.$api.update(obj)
    .then(response => {
      (response as any[]).forEach(obj => this.$set(this.items, this.items.length,obj))
    }
    );
  }

  public onDelete() {
    var checkedItems = this.items.filter((obj, index) => (this.$refs.listBox as Components.Grid).checked[index]);
    if(checkedItems.length == 0){
      this.$api.modal.show('', '削除したいファイルを選択して下さい。', true, null);      
      return;
    }
    this.$api.removeFiles(checkedItems)
    .then(response=>{      
      this.onParentIdChanged();
    });

  }

  public onDownload(index: number) {
    this.onSelected(index);
    const query = new Common.UploadFileDownloadQuery();
    query.uploadFile = this.selectedItem;
    this.$api.download(query);
  }

  //***********   要実装箇所(終わり) *************/
}
